import { render } from "./ComplianceScoreWithMisconfiguredSpendWidget.vue?vue&type=template&id=49cdcbbe"
import script from "./ComplianceScoreWithMisconfiguredSpendWidget.vue?vue&type=script&lang=js"
export * from "./ComplianceScoreWithMisconfiguredSpendWidget.vue?vue&type=script&lang=js"

import "./ComplianceScoreWithMisconfiguredSpendWidget.vue?vue&type=style&index=0&id=49cdcbbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__